import { useMutation } from "@apollo/client";
import {
    IInsertMQTTBrokerSettingReturn,
    IUpdateMQTTBrokerSettingReturn,
    IMQTTBrokerSettingsEntity,
} from "./MQTTBrokerSettingsEntityInterfaces";
import { addMqttBrokerSetting, updateMqttBrokerSetting } from "api/queries/MQTTBrokesSettingsAPI";

export const MQTTBrokerSettingsEntity: IMQTTBrokerSettingsEntity = {
    InsertMQTTBrokerSetting: function (): IInsertMQTTBrokerSettingReturn {
        const [insertMQTTBrokerSetting, { error }] = useMutation(addMqttBrokerSetting);
        return {
            insertMQTTBrokerSetting,
            apolloMutationError: error,
        };
    },
    UpdateMQTTBrokerSetting: function (): IUpdateMQTTBrokerSettingReturn {
        const [updateMQTTBrokerSetting, { error }] = useMutation(updateMqttBrokerSetting);
        return {
            updateMQTTBrokerSetting,
            apolloMutationError: error,
        };
    },
};
